if (!window.productCardVideoAutoplayInitialized) {
  window.productCardVideoAutoplayInitialized = true;

  const cardVideoObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    },
    { threshold: 0.25 }
  );

  function observeCardVideos(root) {
    (root || document).querySelectorAll('[data-card-autoplay-video]').forEach((video) => {
      cardVideoObserver.observe(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => observeCardVideos());
  } else {
    observeCardVideos();
  }

  document.addEventListener('shopify:section:load', (event) => {
    observeCardVideos(event.target);
  });
}
